const TokenKey = 'Token';
const UserInfoKey = 'Allinpay-User-Info';
const TableColumn = 'table-column';

export function getToken () {
  return localStorage.getItem(TokenKey);
}

export function setToken (token) {
  return localStorage.setItem(TokenKey, token);
}

export function removeToken () {
  return localStorage.removeItem(TokenKey);
}

export function getUserInfo () {
  return localStorage.getItem(UserInfoKey) === null ? null : JSON.parse(localStorage.getItem(UserInfoKey));
}

export function setUserInfo (userInfo) {
  return localStorage.setItem(UserInfoKey, JSON.stringify(userInfo));
}

export function removeUserInfo () {
  return localStorage.removeItem(UserInfoKey);
}
// 审批详情存储当前操作人自定义table列
export function getUserTableColumn () {
  return localStorage.getItem(TableColumn) === null ? null : JSON.parse(localStorage.getItem(TableColumn));
}

export function setUserTableColumn (tableColumn) {
  return localStorage.setItem(TableColumn, JSON.stringify(tableColumn));
}
/* 根据菜单编码获取当前用户的页面功能 */
export function getFunctionsAuthByMenuCode (menuCode) {
  let functions = null;
  let userInfo = getUserInfo();
  if (userInfo) {
    userInfo.menus.forEach(menu => {
      menu.children.forEach(secondMenu => {
        if (secondMenu.name === menuCode) {
          functions = secondMenu.children;
        }
      });
    });
  }
  if (functions && functions.length) {
    functions = functions.map((item) => item.functionId);
  }
  return functions || [];
}



// WEBPACK FOOTER //
// ./src/utils/auth.js